import { tfpapi } from './trainfitpro-apiservice';
import { AcceptanceTypesEnum, IUser, WebPush } from '../models/usermodel';
import { MemberTypeEnum } from '../models/permissionsmodel';

// Allow dependency injection for testing
import { createApiInjector } from './api-injector';
export const systemApiInjector = createApiInjector(tfpapi);

export class SystemService {

  static async saveOrUpdateUserDtls(providerUserUUID: string, img: string) {
    const result = await systemApiInjector.api.system.dtls.put({ providerUserUUID }, {
      img,
    });

    return result.data && result.data.result;
  }

  static async getUserDtls(me: string) : Promise<IUser|undefined> {
    const result = await systemApiInjector.api.system.dtls.getOne({ providerUserUUID: me });

    if (!(result.data && result.data.result)) {
      return;
    }

    const data = result.data.result;

    return {
      ...data,
      idProvider: data.idProvider == null ? undefined : data.idProvider,
      phone: data.phone == null ? undefined : data.phone,
      webPush: data.webPush as WebPush[],
      memberType: data.memberType as MemberTypeEnum,
      subscriptionType: data.subscriptionType ?? undefined,
      subscriptionStartDate: data.subscriptionStartDate ?? undefined,
      subscriptionEndDate: data.subscriptionEndDate ?? undefined,
      lastLogin: data.lastLogin ?? undefined,
    };
  }

  static async getOtherUsersDtls(them: string[]) : Promise<IUser[]> {
    const result = await systemApiInjector.api.system.dtls.get({ items: them });

    if (!(result.data && result.data.result)) {
      return [];
    }

    const data2 = result.data.result;

    return data2.map((data) => ({
      ...data,
      providerUserUUID: 'unknown',
      phone: data.phone == null ? undefined : data.phone,
      memberType: MemberTypeEnum.client, // at least for now
      lastLogin: data.lastLogin ?? undefined,
    }));
  }

  static async signIn(user: IUser): Promise<boolean> {
    const {
      providerUserUUID,
      firstName,
      lastName,
      email,
      idProvider,
      phone,
      img,
    } = user;

    const result = await systemApiInjector.api.system.signin({
      providerUserUUID,
      firstName,
      lastName,
      email,
      idProvider,
      phone,
      img,
    });

    // console.log('signIn', result);


    return (result.response.status == 201 && result.data!.success && (!!result.data!.result));
  }

  static async acceptance(userUUID: string, acceptance: AcceptanceTypesEnum) {
    const result = await systemApiInjector.api.system.acceptance.update({ userUUID, type: acceptance as "AcceptTaC" | "AcceptPP" | "WithdrawTaC" | "WithdrawPP" });

    return result.data!.success;
  }

  static async subscribeWebPush(providerUserUUID: string, webPush: WebPush) {
    const result = await systemApiInjector.api.system.subscribe.update({ providerUserUUID, webPush: webPush });

    return result.data!.success;
  }

}
